/**
 * Grid layout utilities for the player video card grid.
 *
 * getGridCols returns Tailwind CSS grid-cols classes for a given player count.
 * getColCount returns the numeric column count for the current breakpoint —
 * use this alongside getGridCols when you need grid-template-rows: repeat(N, 1fr).
 *
 * Layout philosophy:
 *   - 1 player  → full-width single card
 *   - 2 players → stacked on small mobile, side-by-side on sm+
 *   - 3-4       → 2 columns on all sizes (maximises card height)
 *   - 5-6       → 2 cols mobile, 3 cols sm+
 *   - 7-8       → 2 cols mobile, 4 cols sm+
 */
export function getGridCols(count) {
  if (count <= 1) return 'grid-cols-1';
  if (count === 2) return 'grid-cols-1 sm:grid-cols-2';
  if (count <= 4) return 'grid-cols-2';
  if (count <= 6) return 'grid-cols-2 sm:grid-cols-3';
  return 'grid-cols-2 sm:grid-cols-4';
}

/**
 * Returns the numeric column count that getGridCols would produce at the
 * current viewport width (sm breakpoint = 640 px, matching Tailwind default).
 * Pass isSm from a resize-aware hook so the value stays current.
 */
export function getColCount(count, isSm = true) {
  if (count <= 1) return 1;
  if (count === 2) return isSm ? 2 : 1;
  if (count <= 4) return 2;
  if (count <= 6) return isSm ? 3 : 2;
  return isSm ? 4 : 2;
}
